import React, { useContext, useState } from "react";
import { CiCreditCard1, CiHeart, CiPower } from "react-icons/ci";
import { GoGear } from "react-icons/go";
import { IoChevronForward } from "react-icons/io5";
import { TiClipboard } from "react-icons/ti";
import { AppContextProvider } from "../../App";
import { FiSun } from "react-icons/fi";
import { FaRegMoon } from "react-icons/fa";

export const AcMobileDropDown = ({ setLoggedUser }) => {
  const { toggleTheme } = useContext(AppContextProvider);
  const [darkLight, setDarkLight] = useState(
    () => localStorage.getItem("dark") === "true"
  );
  const handleThemeToggle = (theme) => {
    localStorage.setItem("dark", theme === "dark");
    setDarkLight(theme === "dark");
    toggleTheme(theme);
    };
  return (
    <div
      className={
        "absolute dark:bg-[#1C1C1C] dark:text-[#cccccc]  z-[1000] drop-shadow-xl w-full rounded-b-lg lg:w-fit  top-[75px] right-0 bg-white "
      }
    >
      <ul className="flex px-4 pt-6 flex-col gap-8">
        <div className="lg:hidden flex items-center space-x-3">
          <img
            alt=""
            className=" rounded-xl object-cover w-9 h-9"
            src="https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=800"
          />
          <div>
            <p>Chrsitine Smith</p>
            <p>christine.smith@company.com</p>
          </div>
        </div>
        <a
          href="/Pages/AccountSettings/1"
          className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2"
        >
          <div className="flex items-center space-x-2">
            <TiClipboard className="text-2xl" />
            <p>My Orders</p>
          </div>
          <IoChevronForward className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2" />
        </a>
        <a
          href="/Pages/AccountSettings/2"
          className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2"
        >
          <div className="flex items-center space-x-2">
            <CiHeart className="text-2xl" />
            <p>Favourite Products</p>
          </div>
          <IoChevronForward className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2" />
        </a>
        <a
          href="/Pages/AccountSettings/3"
          className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2"
        >
          <div className="flex items-center space-x-2">
            <CiCreditCard1 className="text-2xl" />
            <p>Billing Details</p>
          </div>
          <IoChevronForward className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2" />
        </a>
        <a
          href="/Pages/AccountSettings/4"
          className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2"
        >
          <div className="flex items-center space-x-2">
            <GoGear className="text-2xl" />
            <p>Account Settings</p>
          </div>
          <IoChevronForward className="cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2" />
        </a>
        <div
          onClick={() => {
            localStorage.setItem('logged', false)
          }}
          className={`text-red-500 cursor-pointer rounded-lg px-3 py-1 flex items-center space-x-2`}
        >
          <CiPower className="text-2xl" />
          <p>Logout</p>
        </div>
         {/* <----------------------- toggle light and dark mode -----------------------> */}
      <div
        id="darklight"
        className="flex h-10 border dark:border-gray-500 rounded-lg mb-6"
      >
        <FiSun
          onClick={() => handleThemeToggle("light")}
          className={`cursor-pointer w-1/2 h-full p-2 text-4xl  ${
            !darkLight ? "border border-black dark:border-white rounded-lg" : ""
          }`}
        />
        <FaRegMoon
          onClick={() => handleThemeToggle("dark")}
          className={`cursor-pointer w-1/2 h-full text-4xl p-2 ${
            darkLight ? "border border-black dark:border-white rounded-lg" : ""
          }`}
        />
      </div>
      </ul>
    </div>
  );
};
